(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["shreyas-joshi-portfolio"] = factory();
	else
		root["shreyas-joshi-portfolio"] = factory();
})(globalThis, () => {
return 